import { useState, useEffect, useCallback } from "react";

export function CountdownTimer({ closingTime }) {
  // Helper: convert backend UTC string to JS Date safely
  const parseUTC = (timeStr) => {
    if (!timeStr) return null;

    // If string already has Z (ISO 8601 UTC), just parse
    if (timeStr.endsWith("Z")) return new Date(timeStr);

    // If string is like "YYYY-MM-DD HH:MM:SS", convert to ISO
    const isoStr = timeStr.replace(" ", "T") + "Z";
    return new Date(isoStr);
  };

  const calculateTimeLeft = useCallback(() => {
    const nowUTC = new Date(); // current time
    const endUTC = parseUTC(closingTime);

    if (!endUTC) return null;

    const difference = endUTC - nowUTC;
    if (difference <= 0) return null;

    return {
      days: String(Math.floor(difference / (1000 * 60 * 60 * 24))).padStart(
        2,
        "0"
      ),
      hours: String(Math.floor((difference / (1000 * 60 * 60)) % 24)).padStart(
        2,
        "0"
      ),
      minutes: String(Math.floor((difference / 1000 / 60) % 60)).padStart(
        2,
        "0"
      ),
      seconds: String(Math.floor((difference / 1000) % 60)).padStart(2, "0"),
    };
  }, [closingTime]);

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timerId = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timerId);
  }, [calculateTimeLeft]);

  // Expired view
  if (!timeLeft) {
    // return (
    //   <div
    //     className="countdown-timer"
    //     style={{
    //       fontWeight: 800,
    //       fontSize: "20px",
    //       gap: "7px",
    //       display: "flex",
    //     }}
    //   >
    //     <div>Expired</div>
    //   </div>
    // );

    return;
  }

  // Countdown display
  return (
    <div
      className="countdown-timer"
      style={{
        fontWeight: 500,
        fontSize: "15px",
        gap: "7px",
        display: "flex",
      }}
    >
      <div className="time">
        {timeLeft.days}
        <span>Day</span>
      </div>
      :
      <div className="time">
        {timeLeft.hours}
        <span>Hours</span>
      </div>
      :
      <div className="time">
        {timeLeft.minutes}
        <span>Min</span>
      </div>
      :
      <div className="time">
        {timeLeft.seconds}
        <span>Sec</span>
      </div>
    </div>
  );
}
